import 'chosen-js/chosen.jquery';
import 'chosen-js/chosen.min.css';

import autobind from 'class-autobind';

import TrainerReduction from 'atg/api/TrainerReduction';
import * as Text from 'shared/utils/Text';

import JockeyTrainerReductionView, {
  TYPE_TRAINER,
} from './JockeyTrainerReductionView';

export default class TrainerReductionView extends JockeyTrainerReductionView {
  constructor() {
    super(...arguments);
    autobind(this, TrainerReductionView.prototype);
    this.initializeAsViewType(TYPE_TRAINER);
  }

  getGridClass() {
    return 'view-trainer-reduction';
  }

  // ---------------------------------------- MENU ----------------------------------------

  getViewTitle() {
    return Text.get('view-trainer', this.getNumber(TrainerReductionView));
  }

  getMenuTitle() {
    return Text.get('view-trainer', this.getNumber(TrainerReductionView));
  }

  // ---------------------------------------- DATA ----------------------------------------

  getReduction() {
    return (
      this.getAPI().betInformation.getReductionSet().getTrainerReduction() ||
      new TrainerReduction()
    );
  }
}
